import { ID, LineItem, Lot } from 'types';
import { bySNo } from '@utils/sorting';

const setLotId = (lineItems: LineItem[], lotId: ID): LineItem[] => (
  lineItems?.map((lineItem: LineItem): LineItem => ({
    ...lineItem,
    lot_id: lotId,
  }))
);

export const sortBySNo = (lots: Lot[]): Lot[] => (
  lots?.sort(bySNo).map((lot: Lot) => ({
    ...lot,
    line_items: setLotId(lot.line_items, lot.id),
  }))
);

export const expandAllLots = (lots: Lot[]): Lot[] => (
  sortBySNo(lots.map((lot: Lot) => ({ ...lot, _collapsed: false })))
);
